import '../i18n';
import {useTranslation} from 'react-i18next';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import customAnalytics from '../util/custom-analytics';

function PaymentSuccess() {
    const {t: lnT} = useTranslation();

    const history = useHistory();
    const location = useLocation();

    const redirect = () => {
        const params = new URLSearchParams(location.search);
        const source = params.get('source');
        const hasToken = Boolean(localStorage.getItem('token'));

        if (source === 'credit_topup' && hasToken) {
            history.replace('/?settingsTab=billing_usage&openCreditTopUp=1&topupStatus=processing');
            return;
        }

        if (hasToken) {
            history.replace('/');
            return;
        }

        history.replace('/login');
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        customAnalytics.purchase_completed(params.get('source'));

        const timeoutId = setTimeout(() => {
            redirect();
        }, 2000);
        return () => clearTimeout(timeoutId);
    }, [location.search]);

    return (
        <div
            style={{
                backgroundColor: '#fafafa',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex'
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ fontSize: 18, fontWeight: 500 }}>{lnT('common:successfullyPurchased')}</div>
                <div style={{ marginTop: 16 }}>{lnT('common:youWillBeRedirectedToLuckynoteIn')}</div>
                 {/* <div onClick={() => redirect()}>Redirect now</div> */}
            </div>
        </div>
    );
}

export default PaymentSuccess;
